import { call, put, takeLatest } from 'redux-saga/effects';
import * as apis from '@/apis/promoConfigs';
import * as actions from '@/actions/promoConfigs';
import {
  CHECK_IF_PROMO_CONFIGURED_REQUEST
} from '@/actions/promoConfigs/actionTypes';
import {
  ICheckIfPromoConfigured
} from '@/actions/promoConfigs/models/types';
import { setPromoConfigToken } from '@/helpers/axios';

function* checkIfPromoConfigured({ payload }: ICheckIfPromoConfigured) {
  try {
    const result = yield call(apis.checkIfPromoConfigured, payload);
    yield put(actions.checkIfPromoConfigured.success(result.data));
    setPromoConfigToken(result.data.promoConfigPresent);
  } catch (error) {
    yield put(actions.checkIfPromoConfigured.failure(error));
  }
}

export default function* promoConfigurationSagas() {
  yield takeLatest(CHECK_IF_PROMO_CONFIGURED_REQUEST, checkIfPromoConfigured);
}
